import { render, staticRenderFns } from "./SideMarginsWrapper.vue?vue&type=template&id=7701e7d1&"
import script from "./SideMarginsWrapper.vue?vue&type=script&lang=js&"
export * from "./SideMarginsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SideMarginsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports